import { Card } from '.'
import { BRAND } from '../../constants'
import { Space } from '../../models/types/Space.type'
import { TitleWithHighlight } from '../UI/index'
import { Button } from './Card'

type SpaceCard = {
  button: Button[]
}

type GalleryProps = {
  spaceCard: SpaceCard
  spaces: Space[]
  venuesHeading?: string
  displayLocation: string
  nicheOrEventName: string
  locale: string
}

export const Gallery = ({
  spaceCard,
  spaces,
  venuesHeading = '',
  displayLocation,
  nicheOrEventName,
  locale
}: GalleryProps) => {
  return (
    <div className='container' id='galleryTop' role='grid'>
      {venuesHeading.length > 0 && (
        <section className='gallery-heading'>
          <TitleWithHighlight h2 string={venuesHeading} highlight={{ displayLocation, nicheOrEventName }} />
        </section>
      )}
      <div className='wrap'>
        {spaces.map((space) => (
          <Card key={space.id} space={space} button={spaceCard.button} locale={locale} />
        ))}
      </div>
      <style jsx>{`
        .gallery-heading {
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin: 32px 0px;
          width: 100%;
        }
        .container {
          width: 100%;
          max-width: 1350px;
          display: flex;
          justify-content: center;
          align-items: center;
          flex-direction: column;
          margin: 32px 0px;
        }
        .wrap {
          display: flex;
          flex-wrap: wrap;
          justify-content: center;
          align-items: center;
          gap: 16px;
          width: 100%;
          max-width: 1280px;
          padding: 0 32px;
        }

        @media screen and (max-width: ${BRAND.media.small}px) {
          .wrap {
            padding: 0 16px;
          }
        }
      `}</style>
    </div>
  )
}
